/**
 * Dark ink → light mark for sponsor SVGs on neon panels (shared by SponsorLogo + footer).
 * Matches the Puttzin login panel idea: invert + brand glow (not a separate asset).
 */
export const SPONSOR_MARK_IMG_FILTER =
  'brightness(0) invert(1) drop-shadow(0 0 10px rgba(0, 173, 239, 0.45)) drop-shadow(0 0 16px rgba(230, 30, 140, 0.14))'

export const sponsorMarkPanelClass =
  'rounded-xl border-2 border-[#00ADEF]/85 bg-gradient-to-br from-[#1a0f22] via-[#0f1420] to-[#12081c] shadow-[0_0_0_1px_rgba(230,30,140,0.3),0_0_28px_rgba(0,173,239,0.28),0_0_48px_rgba(0,173,239,0.08),inset_0_1px_0_rgba(255,255,255,0.07)]'
